import { RECEIVE_ALL_DEVICES } from '../actions/device_actions';
import { RECEIVE_DEVICE_PROFILE } from '../actions/management_actions'
var _ = require('lodash')
const device_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    
    switch (action.type) {
        case RECEIVE_ALL_DEVICES:
            const devices = _.mapKeys(action.devices, "_id")
            let normalizedDevices = { ...oldState, ...devices }
            return normalizedDevices
        case RECEIVE_DEVICE_PROFILE:
            let nextState = _.cloneDeep(oldState)
            nextState[action.device._id] = action.device
            return nextState
        default:
            return oldState;
    }
};

export default device_reducer;